import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import Navbar from "../../pages/Dashboard/Navbar";
import classes from "./subscription.module.css";
import ServerCall from "../../serverCall";
import BVAButton from "../../components/BVAButton/BVAButton";
import Swal from "sweetalert2";
const SubscriptionSettings = ({ user }) => {
  const serverCall = ServerCall();
  const [subscription, setSubscription] = useState({});
  const [subscriptionDate, setSubscriptionDate] = useState({});
  const [loading, setLoading] = useState(false);
  const getStripeProduct = async () => {
    const response = await serverCall.customAxios.get(
      `/stripe-subscription/${user?.uid}`,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    setSubscription(response?.data?.subscription);
    handleSubscriptionDate(response?.data?.subscription);
  };
  const handleCancelSubscription = async () => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes Cancel",
      cancelButtonText: "No",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          // Perform your action here if confirmed
          setLoading(true);
          await serverCall.customAxios.post(
            `/cancel-subscriptions/${user?.uid}`,
            {
              type: "cancelled",
            },
            {
              headers: {
                "Content-Type": "application/json",
              },
            }
          );
          setLoading(false);

          getStripeProduct();
        } catch (error) {
          console.log(error);
        }
      } else {
        // Perform your action here if canceled
        console.log("Action canceled!");
      }
    });
  };
  const handleSubscriptionDate = (data) => {
    try {
      // Trial Start
      const trialStart = new Date(data.trial_start * 1000).toLocaleString();
      const trialEnd = new Date(data.trial_end * 1000).toLocaleString();
      const startTime = new Date(
        data.current_period_start * 1000
      ).toLocaleString();
      const endTime = new Date(data.current_period_end * 1000).toLocaleString();
      setSubscriptionDate({ trialEnd, startTime, endTime, trialStart });
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    getStripeProduct();
  }, []);
  return (
    <div>
      <Navbar />

      <div className={classes.subscriptionContainer}>
        <h2>
          Subscription{" "}
          {subscription?.status === "trialing" ||
          subscription?.status === "active"
            ? "Active"
            : "Inactive"}
        </h2>
        <div className="flex justify-end">
          <div className={classes.subscriptionCard}>
            <h2>Subscription Management</h2>
            <p>Manage your subscription details here.</p>
            {!subscription?.id && (
              <div className="absolute inset-0 flex items-center justify-center">
                <span className="absolute flex h-3 w-3">
                  <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-sky-400 opacity-75"></span>
                  <span className="relative inline-flex rounded-full h-3 w-3 bg-sky-500"></span>
                </span>
              </div>
            )}
            <div className="mt-4 flex flex-col gap-3">
              {subscription?.status === "trialing" && (
                <>
                  <div className="grid grid-cols-[180px_1fr]">
                    <strong>Trial Start:</strong> {subscriptionDate?.trialStart}
                  </div>
                  <div className="grid grid-cols-[180px_1fr]">
                    <strong>Trial End:</strong> {subscriptionDate?.trialEnd}
                  </div>
                </>
              )}
              {subscription?.status === "active" && (
                <>
                  <div className="grid grid-cols-[180px_1fr]">
                    {" "}
                    <strong>Subscription Start:</strong>{" "}
                    {subscriptionDate?.startTime}
                  </div>
                  <div className="grid grid-cols-[180px_1fr]">
                    <strong>Subscription End:</strong>{" "}
                    {subscriptionDate?.endTime}
                  </div>
                </>
              )}
              <div className="grid grid-cols-[180px_1fr] capitalize">
                <strong>Status:</strong> {subscription?.status}{" "}
                {subscription.cancel_at_period_end &&
                  "(Last subscription ongoing.)"}
              </div>
            </div>
            <div className="flex justify-end mt-4">
              <BVAButton
                onClick={handleCancelSubscription}
                disabled={
                  loading ||
                  subscription.cancel_at_period_end ||
                  !subscription?.id
                }
                loading={loading}
                type="submit"
                kind="danger"
              >
                {subscription.cancel_at_period_end ? "Cancelled " : "Cancel "}
                Subscription
              </BVAButton>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  user: state.user,
});

export default connect(mapStateToProps)(SubscriptionSettings);
